import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@material-ui/core';
import CommonDataGrid from '../../../shared/components/data-grid';
import { executeApiAction } from '../../../shared/utility/apiHelper';
import { getVehicleTowingRecords } from '../../services/userService';
import { TOWING_GRID_COLUMNS } from '../../constants/vehicleTowingTabConstants';

const VehicleTowingTab = ({ ptsVehicleID }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [towingRecords, setTowingRecords] = useState([]);

  const loadTowingRecords = useCallback(async () => {
    if (!ptsVehicleID) return;

    await executeApiAction({
      setLoading,
      dispatch,
      action: () => getVehicleTowingRecords(ptsVehicleID),
      onSuccess: (data) => setTowingRecords(data),
    });
  }, [dispatch, ptsVehicleID]);

  useEffect(() => {
    loadTowingRecords();
  }, [loadTowingRecords]);

  return (
    <Box className="person-names-tab__grid-wrap">
      <CommonDataGrid
        rows={towingRecords}
        columns={TOWING_GRID_COLUMNS}
        getRowId={(row) => row.ptsTowingID}
        loading={loading}
        autoHeight
        toolbar={{
          showSearch: true,
          showColumnSelector: true,
          showFilter: true,
          showDensity: true,
          showExport: true,
          printTitle: 'Vehicle Towing',
        }}
      />
    </Box>
  );
};

export default VehicleTowingTab;
